module.exports = __webpack_public_path__ + "img/90.a3621302.png";